export default function FeedBack(){
    return <a className="comment-btn" target="_blank" rel="noreferrer" href="https://www.instagram.com/muisictheory/"><button className="btn" style={{marginTop:"2rem", marginBottom:"2rem"}}type="button">Comment</button></a>
}